import { Grid } from '@mui/material';
import { PqrDatesInfoProps } from './props';
import { Accordion } from '../../../../../components/general/accordion';
import InsertInvitationIcon from '@mui/icons-material/InsertInvitation';
import { usePqrDatesInfo } from './hook';
import DateTimePickerField from '../../../../../components/general/fields/dateTimePickerField';
import dayjs from 'dayjs';
import { Checkbox } from '../../../../../components/general/fields/checkbox';

export const PqrDatesInfo = ({ datesInfo, createdAt }: PqrDatesInfoProps) => {
    const { formik } = usePqrDatesInfo(datesInfo, createdAt);
    return (
        <Accordion
            title="FECHAS PQR"
            icon={<InsertInvitationIcon sx={{ color: 'primary.main' }} />}
            defaultExpanded={false}
            mt={0}
        >
            <Grid
                container
                spacing={{ xs: 1.5, md: 1.5 }}
                columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            >
                <Grid item xs={12} sm={4}>
                    <DateTimePickerField
                        label="Fecha de radicación cliente"
                        name="customerFilingDate"
                        size="small"
                        value={formik.values.customerFilingDate}
                        disabled
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <DateTimePickerField
                        label="Fecha de notificación trámite"
                        name="notificationProcedureDate"
                        size="small"
                        value={formik.values.notificationProcedureDate}
                        disabled
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <DateTimePickerField
                        label="Fecha de registro sistema"
                        name="createdAt"
                        size="small"
                        value={dayjs(createdAt).subtract(5, 'hours')}
                        disabled
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <DateTimePickerField
                        label="Fecha trámite"
                        name="processingDate"
                        size="small"
                        value={formik.values.processingDate}
                        disabled
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <DateTimePickerField
                        label="Fecha de suspensión"
                        name="suspensionDate"
                        size="small"
                        value={formik.values.suspensionDate}
                        disabled
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Checkbox
                        label="Enviar email - Ampliación de la información"
                        checked={Boolean(
                            formik.values.sendEmailExpansionInformation
                        )}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <DateTimePickerField
                        label="Fecha de reactivación"
                        name="reactivationDate"
                        size="small"
                        value={formik.values.reactivationDate}
                        disabled
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <DateTimePickerField
                        label="Fecha de prórroga"
                        name="extensionDate"
                        size="small"
                        value={formik.values.extensionDate}
                        disabled
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Checkbox
                        label="Enviar email - Prórroga"
                        checked={Boolean(formik.values.sendEmailExtension)}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <DateTimePickerField
                        label="Fecha alerta SFC"
                        name="alertSFCDate"
                        size="small"
                        value={formik.values.alertSFCDate}
                        disabled
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <DateTimePickerField
                        label="Fecha de respuesta"
                        name="responseDate"
                        size="small"
                        value={formik.values.responseDate}
                        disabled
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Checkbox
                        label="Enviar email - Respuesta"
                        checked={Boolean(formik.values.sendEmailResponse)}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <DateTimePickerField
                        label="Fecha de notif, respuesta"
                        name="notificationResponseDate"
                        size="small"
                        value={formik.values.notificationResponseDate}
                        disabled
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <DateTimePickerField
                        label="Fecha de SAC"
                        name="sacDate"
                        size="small"
                        value={formik.values.sacDate}
                        disabled
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <DateTimePickerField
                        label="Fecha de Furag"
                        name="furagDate"
                        size="small"
                        value={formik.values.furagDate}
                        disabled
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <DateTimePickerField
                        label="Fecha de cierre"
                        name="closingDate"
                        size="small"
                        value={formik.values.closingDate}
                        disabled
                    />
                </Grid>
            </Grid>
        </Accordion>
    );
};
